import { useEffect } from "react";
import { useLocation } from "wouter";
import { trpc } from "@/lib/trpc";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function ForumLogin() {
  const [, setLocation] = useLocation();
  const { data: authData, isLoading } = trpc.auth.getForumAuthUrl.useQuery();

  const handleLogin = () => {
    if (authData?.url) {
      // Save state to localStorage for verification
      localStorage.setItem('forum_oauth_state', authData.state);
      // Redirect to forum OAuth page
      window.location.href = authData.url;
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="w-full max-w-md glass border-primary/20">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">使用论坛账号登录</CardTitle>
          <CardDescription>
            使用您的论坛账号登录域名价格对比工具
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-muted/50 p-4 rounded-lg space-y-2 text-sm">
            <p className="font-medium">登录后您可以：</p>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>添加域名到监控列表</li>
              <li>接收域名可注册通知</li>
              <li>保存您的搜索历史</li>
            </ul>
          </div>

          <Button 
            onClick={handleLogin}
            disabled={isLoading || !authData}
            className="w-full"
            size="lg"
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                加载中...
              </>
            ) : (
              <>
                <ExternalLink className="mr-2 h-4 w-4" />
                前往论坛授权
              </>
            )}
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            点击后将跳转到论坛进行授权确认
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
